import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { getDestinations } from '../../api/destinationApi';
import DestinationCard from '../destinations/DestinationCard';
import { Loading } from '../shared';
import '../../styles/destinations.scss';

const CATEGORIES = [
	{ value: '', label: 'All' },
	{ value: 'viewpoint', label: 'Treks' },
	{ value: 'unesco_site', label: 'UNESCO' },
	{ value: 'national_park', label: 'Parks' },
	{ value: 'lake', label: 'Lakes' },
	{ value: 'temple', label: 'Temples' },
];

function HomeDiscoverPanel() {
	const [destinations, setDestinations] = useState([]);
	const [loading, setLoading] = useState(true);
	const [category, setCategory] = useState('');
	const [query, setQuery] = useState('');

	useEffect(() => {
		getDestinations({ per_page: 50 })
			.then((res) => setDestinations((res.data && res.data.destinations) || []))
			.catch(() => setDestinations([]))
			.finally(() => setLoading(false));
	}, []);

	const filtered = useMemo(() => {
		let list = destinations;
		if (category) list = list.filter((d) => d.category === category);
		if (query.trim()) {
			const q = query.toLowerCase();
			list = list.filter((d) =>
				d.name.toLowerCase().includes(q)
				|| (d.summary && d.summary.toLowerCase().includes(q))
				|| (d.district && d.district.name.toLowerCase().includes(q))
			);
		}
		return list;
	}, [destinations, category, query]);

	return (
		<div className="home-panel">
			<div className="home-panel__head">
				<div>
					<h2 className="home-panel__title">Places in Nepal</h2>
					<p className="home-panel__lead">Every destination guide on one page — tap to read the full story.</p>
				</div>
				<Link to="/provinces" className="home-panel__aside">By province →</Link>
			</div>

			<div className="home-panel__toolbar">
				<input
					type="search"
					className="home-panel__search"
					placeholder="Filter places…"
					value={query}
					onChange={(e) => setQuery(e.target.value)}
					aria-label="Filter destinations"
				/>
				<div className="home-panel__pills" role="tablist" aria-label="Categories">
					{CATEGORIES.map((c) => (
						<button
							key={c.value || 'all'}
							type="button"
							role="tab"
							aria-selected={category === c.value}
							className={`home-panel__pill${category === c.value ? ' home-panel__pill--active' : ''}`}
							onClick={() => setCategory(c.value)}
						>
							{c.label}
						</button>
					))}
				</div>
			</div>

			{loading ? (
				<Loading />
			) : (
				<div className="home-panel__grid home-panel__grid--destinations">
					{filtered.length > 0 ? (
						filtered.map((d) => <DestinationCard key={d.slug} destination={d} />)
					) : (
						<p className="home-panel__empty">No places match — try another filter.</p>
					)}
				</div>
			)}
		</div>
	);
}

export default HomeDiscoverPanel;
